import { Link, useLocation } from 'react-router-dom'
import './Header.css'

function Header() {
  const location = useLocation()

  return (
    <header className="header">
      <div className="header-content">
        <Link to="/" className="logo">
          <h1>BLENDEMIC</h1>
          <p className="tagline">Sick Blends Should Go Viral</p>
        </Link>

        <nav className="nav">
          <Link
            to="/"
            className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
          >
            Search
          </Link>
          <Link
            to="/mixer"
            className={`nav-link ${location.pathname === '/mixer' ? 'active' : ''}`}
          >
            Mixer
          </Link>
          <Link
            to="/blend-bank"
            className={`nav-link ${location.pathname === '/blend-bank' ? 'active' : ''}`}
          >
            Blend Bank
          </Link>
        </nav>
      </div>
    </header>
  )
}

export default Header
